import {
  Container,
  Title,
  Text,
  SimpleGrid,
  Grid,
  Image,
  Tabs,
  List,
  Card,
  Button,
  Group,
  Space,
  Box,
} from "@mantine/core";
import { Carousel } from "@mantine/carousel";
import { IconArrowRight } from "@tabler/icons-react";

function SapMDGAddOn() {
  return (
    <div>
      <section style={{ padding: "4rem" }}>
        <Container size={"lg"} p="lg">
          <Grid align="center">
            <Grid.Col span={{ base: 12, md: 8, lg: 7 }}>
              <Title order={1}>
                PiLog's Material Master Taxonomy for SAP Master Data Governance
                from PiLog Group Achieves SAP® Certified Integration with RISE
                with SAP S/4HANA® Cloud
              </Title>
              <Text my="lg">
                PiLog Group announced today that the SAP Integration and
                Certification Center (SAP ICC) has certified PiLog's Material
                Master Taxonomy for SAP Master Data Governance as integrated
                with RISE with SAP S/4HANA® Cloud using standard integration
                technologies. This integration helps organizations to implement
                best industry practices to improve supply-chain, maintenance &
                procurement processes.
              </Text>
              <Button>Read More</Button>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 4, lg: 5 }}>
              <Image
                src={require("../../Components/Assets/iDQM/Data Quality Management.jpg")}
                alt=""
              />
            </Grid.Col>
          </Grid>
        </Container>
      </section>
      <section style={{ padding: "4rem" }}>
        <Container size={"lg"}>
          <SimpleGrid cols={2} spacing="xl">
            <Image
              src={require("../../Components/Assets/sap-mdg-addon/SAP-MDG_Image2.png")}
              alt="sap-mdg"
            />
            <div>
              <Text>
                This solution offers features which are unique and best in class
                in the industry, including options to create class and
                characteristics and updates to SAP custom tables. In addition,
                the creation and change from PiLog Preferred repository with
                characteristics values drop down from micro services. Other
                salient features include inbuilt workflows configured on 4 roles
                of change requests, duplicate check based on class,
                characteristics, and Part number, Ontology/Taxonomy download and
                transfer and linking reference data to material. This
                functionality helps achieve operational excellence in any
                organization.
              </Text>
              <div>
                <Title order={5} my="md">
                  Aspects of PiLog’s Material Master Taxonomy for SAP Master
                  Data Governance include:
                </Title>
                <List>
                  <List.Item>
                    100% ISO compliant material master data governance
                  </List.Item>
                  <List.Item>100% improved duplicate detection</List.Item>
                  <List.Item>
                    100% improved and accurate searchability
                  </List.Item>
                  <List.Item>
                    50% improved material master descriptions
                  </List.Item>
                  <List.Item>10% savings on inventory costs</List.Item>
                </List>
              </div>
            </div>
          </SimpleGrid>
          <Text mt="xl">
            This solution offers features which are unique and best in class in
            the industry, including options to create class and characteristics
            and updates to SAP custom tables. In addition, the creation and
            change from PiLog Preferred repository with characteristics values
            drop down from micro services. Other salient features include
            inbuilt workflows configured on 4 roles of change requests,
            duplicate check based on class, characteristics, and Part number,
            Ontology/Taxonomy download and transfer and linking reference data
            to material. This functionality helps achieve operational excellence
            in any organization.
          </Text>
        </Container>
      </section>

      <section>
        <Container size={"lg"}>
          <Title mb="xl">PiLog Group</Title>
          <Box my="lg">
            <Text>
              Established in 1996, PiLog Group is a global group of independent
              companies, specializing in Quality Data and Digital Governance and
              Analytical solutions supporting multiple data domains in a variety
              of industries all over the globe. We have many resources operating
              globally including Africa's, America's, Europe, Middle East, Asia,
              etc. The PiLog's solutions are state of the art, focused on
              creating a common business language and managing the rules for the
              creation of high quality, multilingual terminology using Machine
              Learning, Artificial Intelligence technologies, and
              human-augmented algorithms for our customers who are eager to
              transform their businesses digitally. PiLog provides exclusive
              technical dictionaries, industrial libraries with content
              repositories that are the culmination of research, development,
              and execution over the past twenty years embedded into the
              platform of PiLog Data Quality HUB. All our methodologies,
              processes, solutions are compliant with intern
            </Text>
          </Box>
        </Container>
      </section>

      <section>
        <Container size={"lg"}>
          <SimpleGrid cols={2} spacing="xl">
            <div>
              <Title order={2}></Title>
              <Text></Text>
              <Text></Text>
              <Text></Text>
            </div>
            {/* <Image
              src={require("../../Components/Assets/iDQM/Data Cleansing-09.png")}
              alt=""
            /> */}
          </SimpleGrid>
        </Container>
      </section>

      <section>
        <Container size={"lg"}></Container>
      </section>

      <section>
        <Container size={"lg"}>
          <SimpleGrid cols={2} spacing="xl">
            {/* <div>
              <Title order={2}></Title>
              <Text></Text>
              <List spacing="md">
                <List.Item icon={<IconArrowRight size={24} />}></List.Item>
                <List.Item icon={<IconArrowRight size={24} />}></List.Item>
                <List.Item icon={<IconArrowRight size={24} />}></List.Item>
                <List.Item icon={<IconArrowRight size={24} />}></List.Item>
              </List>
            </div> */}
            {/* <Image
              src={require("../../Components/Assets/iDQM/Add-Ons.jpg")}
              alt=""
            /> */}
          </SimpleGrid>
        </Container>
      </section>

      {/* <section>
        <Container size={"lg"}>
          <Card shadow="sm" padding="lg">
            <Title order={3}></Title>
            <Text></Text>
            <Space h="md" />
            <Group position="center">
              <Button></Button>
            </Group>
          </Card>
        </Container>
      </section> */}
    </div>
  );
}

export default SapMDGAddOn;
